import { render, staticRenderFns } from "./LocationsEngland.vue?vue&type=template&id=7262521b&scoped=true&"
import script from "./LocationsEngland.vue?vue&type=script&lang=js&"
export * from "./LocationsEngland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7262521b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsInteractiveMap: require('/opt/build/repo/components/Cards/InteractiveMap.vue').default})
